import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DataService } from './data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'enetsecure';

  currentYear: number = new Date().getFullYear();
    constructor(translate: TranslateService, public dataSvc: DataService) {
      // this language will be used as a fallback when a translation isn't found in the current language
      

      translate.setDefaultLang('en');
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('en');
  }


  submitFeedback(){
    const uatVersion = this.dataSvc.uatVersion;
    const email = "helpdesk@ecomscotland.com";
    const cc = "developers@ecomscotland.com";
    const subject = `Issue found in UAT Testing on version ${uatVersion}`;
    var body = `Please enter the following information below to help us replicate and resolve your issue as best we can.

    URL: ${window.location.href}

    Details of Issue: 

    Screenshot (Attach file manually):

    `;

    if(this.dataSvc.currentUser !== undefined && this.dataSvc.currentUser !== null && this.dataSvc.currentUser.ScheduleCandidate !== null && this.dataSvc.currentUser.ScheduleCandidate !== undefined){
      body += "For Developers \n";
      body += "User Login: " + this.dataSvc.currentUser.ScheduleCandidate.username + " / " + this.dataSvc.currentUser.PIN + "\n";
    }

    if(this.dataSvc.currentExam !== undefined && this.dataSvc.currentExam !== null ){  
      body += "Session ID: " + this.dataSvc.currentExam.Session.SessionId + "\n";
      body += "Schedule ID: " + this.dataSvc.currentExam.Session.ScheduleId + "\n";
      body += "Current Question Index: " + parseInt(this.dataSvc.currentExam.CurrentQuestion +1) + "\n";
      
      if(this.dataSvc.currentQuestion !== null && this.dataSvc.currentQuestion !== undefined){
        body += "Question ID:" + this.dataSvc.currentQuestion.Question.Question.QuestionID +  "\n";
      }
    }

    const mailtoLink = `mailto:${email}?cc=${cc}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink; 
  }
}
